const aboutUsElem = document.querySelector('.about-us');

if (aboutUsElem) {
  const compassImage = document.querySelector('.about-us__image-inner img');

  gsap.to(compassImage, {
    y: '0%',
    rotate: 0,
    scrollTrigger: {
      trigger: aboutUsElem,
      start: 'top 70%',
      end: 'bottom 70%',
      scrub: 1,
    },
  });
}
